module.exports = __webpack_public_path__ + "img/badge_2feuille@2x.c6a24d73.png";